import { render, staticRenderFns } from "./ViewLaneClosureRequestBlockTrafficSignalsAltered.vue?vue&type=template&id=36c77bfe&"
import script from "./ViewLaneClosureRequestBlockTrafficSignalsAltered.vue?vue&type=script&lang=js&"
export * from "./ViewLaneClosureRequestBlockTrafficSignalsAltered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports